import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Navbar from './components/common/Navbar';
import OpenRoute from './components/core/Auth/OpenRoute';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import UpdatePassword from './pages/UpdatePassword';
import VerifyEmail from './pages/VerifyEmail';
import About from './pages/About'
import Contact from './pages/Contact';
import MyProfile from './components/core/Dashboard/MyProfile';
import PrivateRoute from './components/core/Auth/PrivateRoute';
import Dashboard from './pages/Dashboard'
import Settings from './components/core/Dashboard/Settings';
import EnrolledCourses from './components/core/Dashboard/EnrolledCourses';
import Cart from './components/core/Dashboard/Cart'
import { useSelector } from 'react-redux';
import { ACCOUNT_TYPE } from './utils/constants';
import Error from './components/common/Error';
import AddCourse from './components/core/Dashboard/AddCourse';
import MyCourses from './components/core/Dashboard/InstructorCourses';
import EditCourse from './components/core/Dashboard/EditCourse';
import CourseDetails from './pages/CourseDetails';
import Catalog from './pages/Catalog';
import ViewCourse from './pages/ViewCourse';
import VideoDetails from './components/core/ViewCourse/VideoDetails';
import Instructor from './components/core/Dashboard/InstructorDashboard/Instructor';


function App() {
  const { user } = useSelector((state) => state.profile)
  return (
    <div className='w-screen min-h-screen bg-richblack-900 flex flex-col font-inter'>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} ></Route>
        <Route path='/course/:courseId' element={<CourseDetails />} ></Route>
        <Route path='/catalog/:catalogName' element={<Catalog />} ></Route>

        <Route
          path="signup"
          element={
            <OpenRoute>
              <Signup />
            </OpenRoute>
          }
        />
        <Route
          path="login"
          element={
            <OpenRoute>
              <Login />
            </OpenRoute>
          }
        />

        <Route
          path="verify-email"
          element={
            <OpenRoute>
              <VerifyEmail />
            </OpenRoute>
          }
        />

        <Route
          path="forgot-password"
          element={
            <OpenRoute>
              <ForgotPassword />
            </OpenRoute>
          }
        />
        <Route
          path="update-password/:id"
          element={
            <OpenRoute>
              <UpdatePassword />
            </OpenRoute>
          }
        />
        <Route
          path="about"
          element={
            <OpenRoute>
              <About />
            </OpenRoute>
          }
        />
        <Route path="contact" element={<Contact />} />

        <Route
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path='dashboard/my-profile' element={<MyProfile />} />
          <Route path='dashboard/settings' element={<Settings />} />

          {
            user?.accountType === ACCOUNT_TYPE.Student && (
              <>
                <Route path='dashboard/enrolled-courses' element={<EnrolledCourses />} />
                <Route path='dashboard/cart' element={<Cart />} />
              </>
            )
          }
          {
            user?.accountType === ACCOUNT_TYPE.Instructor && (
              <>
                <Route path='dashboard/add-course' element={<AddCourse />} />
                <Route path='dashboard/my-courses' element={<MyCourses />} />
                <Route path="dashboard/edit-course/:courseId" element={<EditCourse />} />
                <Route path='dashboard/instructor' element={<Instructor />} />
              </>
            )
          }
        </Route>

        <Route element={
          <PrivateRoute>
            <ViewCourse />
          </PrivateRoute>
        }>
          {
            user && user?.accountType === ACCOUNT_TYPE.Student &&
            (
              <>
                <Route path='view-course/:courseId/section/:sectionId/sub-section/:subSectionId' element={<VideoDetails />} />
              </>
            )
          }
        </Route>
        <Route path='*' element={<Error />}></Route>
      </Routes>
    </div>
  );
}

export default App;
